import { Component } from '@angular/core';
import { EcaMonotronModule } from '@drc-eca/eca-components-lib';
import { NavComponent } from '../shared/nav/nav.component';
import { WebScannerComponent } from './web-scanner/web-scanner.component';

@Component({
  selector: 'eca-scanner',
  templateUrl: './scanner.component.html',
  styleUrls: ['./scanner.component.scss'],
  imports: [EcaMonotronModule, NavComponent, WebScannerComponent]
})
export class ScannerComponent {

  constructor() { }

}
